import { render, staticRenderFns } from "./login-member.vue?vue&type=template&id=2d63d9e8&scoped=true&"
import script from "./login-member.vue?vue&type=script&lang=ts&"
export * from "./login-member.vue?vue&type=script&lang=ts&"
import style0 from "./login-member.vue?vue&type=style&index=0&id=2d63d9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63d9e8",
  null
  
)

export default component.exports